import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Typography,
  Switch,
  // IconButton,
  withStyles,
  ListItem,
  // ListItemSecondaryAction,
} from '@material-ui/core'
import { Shopping } from 'mdi-material-ui'
import { list, create, read } from 'actions/data'
import AssignmentPool from './AssignmentPool'
import UnassignedWarning from './UnassignedWarning'
import Button from 'components/theme/Button'

const styles = theme => ({
  listItemContainer: {
    listStyle: 'none',
  },
})

class AssignmentPools extends Component {
  state = {
    assignmentPoolSelected: null,
    input: '',
  }

  componentDidMount() {
    this.props.list('account/ap')
    this.props.read(null, 'account/ap/status', null, 'none')
    if (this.props.enabled) {
      this.props.list('contact/a2', null, null, null, true, true)
    }

    if (!Object.keys(this.props.users || {}).length) {
      this.props.list('account/user', 'user_name')
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.enabled && this.props.enabled !== prevProps.enabled) {
      this.props.list('contact/a2', null, null, null, true, true)
    }
  }

  render() {
    const { assignmentPools, classes, create, read, enabled } = this.props

    return typeof this.state.assignmentPoolSelected === 'number' ? (
      <AssignmentPool
        assignmentPoolSelected={this.state.assignmentPoolSelected}
        goBack={() => this.setState({ assignmentPoolSelected: null })}
      />
    ) : (
      <div
        style={{
          textAlign: 'left',
        }}
      >
        <div style={{ marginTop: 10 }}>
          <UnassignedWarning />
        </div>
        <Typography variant="h5" gutterBottom>
          Enable assignment pool?
        </Typography>
        <div>
          <span>
            <Switch
              checked={Boolean(enabled)}
              onChange={e =>
                create({
                  entity: {},
                  entityType: 'account/toggleap',
                  noReturnValue: true,
                  hasSchema: false,
                })
                  .then(() => read(null, 'account/ap/status', null, 'none'))
                  .then(() => this.props.list('account/ap'))
              }
              color="secondary"
            />
          </span>
          <span
            style={{
              color: enabled ? 'green' : 'red',
            }}
          >
            {enabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <div style={{ marginTop: 15, textAlign: 'center' }}>
          {!enabled && (
            <Typography variant="h5" gutterbottom>
              Assignment Pool is disabled.
              <br />
              Please enable assignment pools if you'd like to access this
              feature
            </Typography>
          )}
          {enabled &&
            assignmentPools.map((pool, idx) => {
              const date = new Date(pool.when_created)

              return (
                <ListItem
                  key={`assignmentPoolListItem${pool?.id}`}
                  button
                  onClick={() =>
                    this.setState({ assignmentPoolSelected: pool.id })
                  }
                  classes={{ container: classes.listItemContainer }}
                  style={{
                    borderTop: idx === 0 ? '1px solid gray' : null,
                    borderLeft: '1px solid gray',
                    borderRight: '1px solid gray',
                    borderBottom: '1px solid gray',
                    borderTopLeftRadius: idx === 0 ? 17 : null,
                    borderTopRightRadius: idx === 0 ? 17 : null,
                    borderBottomLeftRadius:
                      idx === assignmentPools?.length - 1 ? 17 : null,
                    borderBottomRightRadius:
                      idx === assignmentPools?.length - 1 ? 17 : null,
                    padding: 10,
                  }}
                  className={
                    idx % 2 === 0 ? classes.listItem : classes.listItemOdd
                  }
                >
                  <Shopping
                    style={{
                      color: '#014c94',
                      marginRight: 5,
                      fontSize: 36,
                    }}
                  />
                  <div style={{ display: 'inline-block' }}>
                    <div
                      style={{
                        fontWeight: 'bold',
                        color: '#014c94',
                        fontSize: 20,
                      }}
                    >
                      {pool.name}
                    </div>
                    <div>
                      <span style={{ fontWeight: 'bold' }}>Created: </span>
                      <span style={{ color: '#014c94', fontWeight: 'bold' }}>
                        {date.toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                  {/* <ListItemSecondaryAction>
									<IconButton>
										<MoreVert />
									</IconButton>
								</ListItemSecondaryAction> */}
                </ListItem>
              )
            })}
          {enabled && (
            <div style={{ marginTop: 12, position: 'relative' }}>
              <div style={{ width: 'calc(100% - 96px)' }}>
                <input
                  value={this.state.input}
                  onChange={e => this.setState({ input: e?.target?.value })}
                  style={{
                    width: '100%',
                    fontSize: 20,
                    lineHeight: '50px',
                    borderRadius: 10,
                  }}
                  placeholder="Enter a name for a new assignment pool"
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              >
                <Button
                  disabled={
                    !this.state.input ||
                    this.state.input?.trim?.() === 'default'
                  }
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    create({
                      entity: {
                        name: this.state.input,
                        pool: {
                          users: Object.keys(this.props.users || {}).map(
                            username => ({ username }),
                          ),
                        },
                      },
                      entityType: 'account/ap',
                    }).then(payload =>
                      this.setState({
                        assignmentPoolSelected: payload.id,
                        input: '',
                      }),
                    )
                  }
                >
                  create
                </Button>
              </div>
              {this.state.input?.trim?.() === 'default' && (
                <div style={{ color: 'red', fontSize: 12, marginTop: 5 }}>
                  You cannot use this name for an assignment pool
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    assignmentPools: Object.values(state.data?.['account/ap'] || {}),
    users: state.data?.['account/user'] || {},
    enabled: state.data?.['account/ap/status']?.enabled,
  }),
  dispatch => bindActionCreators({ list, create, read }, dispatch),
)(withStyles(styles)(AssignmentPools))
